module.exports = __webpack_public_path__ + "static/img/env15.0aff8c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env15.png
// module id = 108
// module chunks = 4